import fetch from "@lib/fetch";
import { API } from "../../config";
import { isAuthenticated } from "./auth";

export const createWebhook = (data) => {
  return fetch(`${API}/v1/webhooks`,{
    mode: 'cors',
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${isAuthenticated().token}`
    },
    body: JSON.stringify(data)
  })
  .then(res => {
    return res.json()
  })
  .catch(error => {
    console.log(error);
  })
};

export const getWebhooks = (env) => {
  console.log(env)
  return fetch(`${API}/v1/webhooks?environment=${env === 'production' ? 'live' : 'test'}`,{
    mode: 'cors',
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${isAuthenticated().token}`
    }
  })
  .then(response => {
    return response.json()
  })
  .catch(error => {
    console.log(error);
  })
};

export const deleteWebhook = (id) => {
  return fetch(`${API}/v1/webhooks/${id}`,{
    mode: 'cors',
    method: "DELETE",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${isAuthenticated().token}`
    }
  })
  .then(response => {
    return response.json()
  })
  .catch(error => {
    console.log(error);
  });
};
